import { IVideos } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/property-api/properties/:param/videos';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  limit: 999,
  orderBy: [{ field: 'orderBy', direction: 'asc' }],
};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IVideos>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'videos/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
